var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-sm-2 mx-1 mt-2 mb-4 d-flex justify-space-between flex-wrap"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }